(function () {
  "use strict";

  // ── Config ──────────────────────────────────────────────────────────────
  var cfg = window.__SK_CHAT_CONFIG || {};
  var API_URL = cfg.apiUrl || "https://erp-api-289183413262.europe-west1.run.app";
  var STORAGE_KEY = "sk_chat_session";
  var SESSION_TTL_MS = 24 * 60 * 60 * 1000; // 24h

  // OpenInsect app — promoted while a photo is being identified (the wait is the
  // species pipeline; the app does exactly this on the go). Region-agnostic
  // links (the App-Store link redirects to the visitor's local store).
  var APP_IOS_URL = cfg.appIosUrl || "https://apps.apple.com/app/id6759469933";
  var APP_ANDROID_URL = cfg.appAndroidUrl || "https://play.google.com/store/apps/details?id=com.silberkraft.insectid";

  // Voice (Gemini Live API): convert http(s) → ws(s) for the WebSocket endpoint
  // and surface the AudioWorklet URL the snippet baked in.
  var VOICE_ENABLED = cfg.voiceEnabled !== false; // default on; snippet can turn off
  var WS_URL = (cfg.wsUrl || API_URL).replace(/^http/, "ws");
  var WORKLET_URL = cfg.workletUrl || null;

  // ── i18n ───────────────────────────────────────────────────────────────
  // Only DE (default) and EN are bundled. Other locales (fr/it/pl/nl/es/da)
  // are lazy-loaded from separate asset files (sk-live-chat-i18n-<locale>.js)
  // to keep the initial bundle small. ~25 KB saved on non-DE/EN visits.
  var I18N = {
    de: {
      headerTitle: "Patricia von Silberkraft",
      headerSub: "Wir helfen dir gerne!",
      openChat: "Chat öffnen",
      closeChat: "Chat schließen",
      chatLabel: "Kundenservice Chat",
      typing: "Silberkraft tippt...",
      statusThinking: "Patricia liest deine Frage…",
      statusFormulating: "Antwort wird formuliert…",
      // Rotation of generic "still working" phrases — shown every ~3s while
      // the model is in tool-call rounds. None reveal what we're doing internally.
      statusRotation: [
        "Patricia liest deine Frage…",
        "Einen kleinen Moment bitte…",
        "Patricia schaut sich das genauer an…",
        "Wir prüfen das gerade für dich…",
        "Patricia bereitet eine Antwort vor…",
        "Gleich für dich da…",
        "Patricia denkt kurz nach…",
        "Wir holen die richtigen Infos für dich raus…",
      ],
      // Shown while a visitor-uploaded photo is being analysed (species ID).
      statusPhoto: "📷 Patricia schaut sich dein Foto genau an…",
      appPromoTitle: "📱 Schon unsere App OpenInsect?",
      appPromoText: "Während ich dein Foto prüfe: Mit OpenInsect bestimmst du Insekten & Pflanzen in Sekunden — kostenlos, direkt unterwegs.",
      placeholder: "Nachricht schreiben…",
      send: "Senden",
      welcome: "Hi! Ich bin Patricia. Schick mir gerne ein Foto vom Schädling oder der Pflanze, frag nach deiner Bestellung oder hol dir Tipps zur Bekämpfung.",
      welcomeHint: "Du kannst auch Fotos hochladen — das Pfötchen-Symbol unten links nutzen.",
      dropHere: "Bild hier ablegen",
      takePhoto: "Foto aufnehmen",
      attachFile: "Bild anhängen",
      examplesTitle: "Beispiele",
      example1: "📷 Was für ein Insekt ist das?",
      example2: "🛒 Wo ist meine Bestellung?",
      example3: "🐛 Hilf mir bei einem Schädling",
      emailPlaceholder: "E-Mail-Adresse (optional)",
      startChat: "Chat starten",
      noEmailHint: "Du kannst auch ohne E-Mail chatten",
      contactTitle: "Kontaktdaten hinterlassen",
      namePlaceholder: "Name (optional)",
      emailRequired: "E-Mail-Adresse",
      phonePlaceholder: "Telefonnummer (optional)",
      submit: "Absenden",
      submitting: "Wird gesendet...",
      contactSuccess: "Vielen Dank! Ein Mitarbeiter wird sich bei dir melden.",
      contactError: "Kontaktdaten konnten nicht gespeichert werden.",
      chatError: "Chat konnte nicht gestartet werden. Bitte lade die Seite neu.",
      sendError: "Nachricht konnte nicht gesendet werden. Bitte versuch es nochmal.",
      errorPrefix: "Fehler",
      callStart: "Anrufen",
      callStop: "Auflegen",
      callConnecting: "Verbinde…",
      callLive: "Live-Anruf",
      callMute: "Stummschalten",
      callUnmute: "Stummschaltung aufheben",
      callMicDenied: "Bitte erlaube uns den Mikrofon-Zugriff, damit du anrufen kannst.",
      callError: "Anruf konnte nicht gestartet werden. Bitte versuch es nochmal.",
      callEnded: "Anruf beendet."
    },
    en: {
      headerTitle: "Patricia from Silberkraft",
      headerSub: "We're happy to help!",
      openChat: "Open chat",
      closeChat: "Close chat",
      chatLabel: "Customer Service Chat",
      typing: "Silberkraft is typing...",
      statusThinking: "Patricia is reading your question…",
      statusFormulating: "Composing the answer…",
      statusRotation: [
        "Patricia is reading your question…",
        "Just a moment please…",
        "Patricia is taking a closer look…",
        "We're checking this for you…",
        "Patricia is preparing your answer…",
        "Almost there…",
        "Patricia is thinking…",
        "Pulling the right info for you…",
      ],
      statusPhoto: "📷 Patricia is taking a close look at your photo…",
      appPromoTitle: "📱 Have you tried our OpenInsect app?",
      appPromoText: "While I check your photo: with OpenInsect you can identify insects & plants in seconds — free, right on the go.",
      placeholder: "Write a message…",
      send: "Send",
      welcome: "Hi! I'm Patricia. Send me a photo of the pest or plant, ask about your order, or get tips on pest control.",
      welcomeHint: "You can upload photos too — use the paperclip icon at the bottom left.",
      dropHere: "Drop image here",
      takePhoto: "Take a photo",
      attachFile: "Attach image",
      examplesTitle: "Try asking",
      example1: "📷 What insect is this?",
      example2: "🛒 Where is my order?",
      example3: "🐛 Help me with a pest",
      emailPlaceholder: "Email address (optional)",
      startChat: "Start chat",
      noEmailHint: "You can also chat without an email",
      contactTitle: "Leave your contact details",
      namePlaceholder: "Name (optional)",
      emailRequired: "Email address",
      phonePlaceholder: "Phone number (optional)",
      submit: "Submit",
      submitting: "Sending...",
      contactSuccess: "Thank you! A team member will contact you soon.",
      contactError: "Contact details could not be saved.",
      chatError: "Chat could not be started. Please reload the page.",
      sendError: "Message could not be sent. Please try again.",
      errorPrefix: "Error",
      callStart: "Call",
      callStop: "Hang up",
      callConnecting: "Connecting…",
      callLive: "Live call",
      callMute: "Mute",
      callUnmute: "Unmute",
      callMicDenied: "Please allow microphone access so you can call us.",
      callError: "Call could not be started. Please try again.",
      callEnded: "Call ended."
    }
  };
  var lang = (cfg.locale || "de").toLowerCase().slice(0, 2);
  // `t` is reassigned once the locale dict is available. Start with DE
  // fallback so the UI is never un-translated even if the async load fails.
  var t = I18N.de;

  // If a sub-file was already loaded (e.g. cached or preloaded), merge it.
  if (window.__SK_CHAT_I18N) {
    for (var k in window.__SK_CHAT_I18N) {
      if (Object.prototype.hasOwnProperty.call(window.__SK_CHAT_I18N, k)) {
        I18N[k] = window.__SK_CHAT_I18N[k];
      }
    }
  }

  function resolveI18n(cb) {
    // DE and EN are bundled — resolve immediately.
    if (I18N[lang]) {
      t = I18N[lang];
      cb();
      return;
    }
    var urls = cfg.i18nUrls || {};
    var url = urls[lang];
    if (!url) {
      // Unknown locale — fall back to DE (already in `t`).
      cb();
      return;
    }
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      if (I18N[lang]) t = I18N[lang];
      cb();
    }
    // Sub-file calls this hook once it's installed itself on window.__SK_CHAT_I18N.
    window.__SK_CHAT_I18N_READY = function (loaded) {
      if (loaded === lang && window.__SK_CHAT_I18N && window.__SK_CHAT_I18N[lang]) {
        I18N[lang] = window.__SK_CHAT_I18N[lang];
      }
      finish();
    };
    var s = document.createElement("script");
    s.src = url;
    s.async = true;
    s.onload = function () {
      // Handle case where hook wasn't set before the sub-file ran.
      if (window.__SK_CHAT_I18N && window.__SK_CHAT_I18N[lang]) {
        I18N[lang] = window.__SK_CHAT_I18N[lang];
      }
      finish();
    };
    s.onerror = finish; // Network error — fall back to DE.
    document.head.appendChild(s);
    // Safety timeout — never block UI longer than 3s.
    setTimeout(finish, 3000);
  }

  // ── Mobile Detection ──────────────────────────────────────────────────
  function isMobile() {
    return window.innerWidth < 768;
  }

  // ── State ───────────────────────────────────────────────────────────────
  var state = {
    open: false,
    sessionId: null,
    sessionToken: null,
    messages: [],
    loading: false,
    contactSent: false,
    showContactForm: false,
    preChatEmail: null,
    pendingAttachments: [],
    // Voice
    voiceStatus: "idle", // "idle" | "connecting" | "live" | "ending"
    voiceMuted: false,
    voiceCtx: null,
    voiceWs: null,
    voiceMicNode: null,
    voiceMicStream: null,
    voicePlayerNode: null,
    voiceTranscriptEl: null,
    voiceLiveAssistantText: "",
    voiceLiveUserText: "",
  };

  var MAX_ATTACHMENTS = 3;
  var MAX_ATTACHMENT_BYTES = 6 * 1024 * 1024;

  // ── DOM Refs ────────────────────────────────────────────────────────────
  var bubble, badge, win, messagesEl, inputEl, sendBtn, typingEl, inputAreaEl;
  var callBtn, voiceBar, voiceMuteBtn, voiceHangupBtn, voiceStatusEl;
  var contactOverlay, preChatOverlay;

  // ── Styles ──────────────────────────────────────────────────────────────
  function injectStyles() {
    var style = document.createElement("style");
    style.textContent =
      // ── Bubble ──
      ".sk-chat__bubble{position:fixed;bottom:24px;right:24px;z-index:2147483647;width:56px;height:56px;border-radius:50%;background:#014c40;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 12px rgba(0,0,0,.2);transition:transform .2s,background .2s,opacity .2s}" +
      ".sk-chat__bubble:hover{transform:scale(1.08);background:#028060}" +
      ".sk-chat__bubble svg{width:28px;height:28px;fill:#fff}" +
      ".sk-chat__badge{position:absolute;top:-2px;right:-2px;min-width:18px;height:18px;border-radius:9px;background:#faa41a;color:#fff;font-size:11px;font-weight:700;display:flex;align-items:center;justify-content:center;padding:0 5px;display:none}" +

      // ── Window (Desktop default) ──
      ".sk-chat__window{position:fixed;bottom:92px;right:24px;z-index:2147483647;width:380px;max-height:560px;border-radius:20px;background:#fff;box-shadow:0 12px 40px rgba(0,0,0,.16),0 2px 6px rgba(0,0,0,.06);display:none;flex-direction:column;overflow:hidden;font-family:Helvetica,Arial,sans-serif;color:#0b0b0b}" +
      ".sk-chat__window.sk-chat--open{display:flex}" +

      // ── Header ──
      // Kompakter, einzeiliger Header — kein Subtitle, kein „Wir helfen dir gerne!“ mehr.
      ".sk-chat__header{background:#014c40;color:#fff;padding:12px 16px;display:flex;align-items:center;gap:10px;flex-shrink:0;min-height:54px}" +
      ".sk-chat__header-icon{width:32px;height:32px;border-radius:50%;background:rgba(255,255,255,.15);display:flex;align-items:center;justify-content:center;overflow:hidden;flex-shrink:0}" +
      ".sk-chat__header-icon img{width:32px;height:32px;object-fit:cover;display:block}" +
      ".sk-chat__header-icon svg{width:20px;height:20px;fill:#fff}" +
      ".sk-chat__header-text{flex:1;min-width:0}" +
      ".sk-chat__header-title{font-size:15px;font-weight:800;line-height:1.15;font-family:Montserrat,Helvetica,Arial,sans-serif;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}" +
      ".sk-chat__header-sub{display:none}" +

      // ── Close button (min 44x44 touch target) ──
      ".sk-chat__close{background:none;border:none;color:#fff;cursor:pointer;opacity:.7;width:44px;height:44px;border-radius:8px;display:flex;align-items:center;justify-content:center;flex-shrink:0;-webkit-tap-highlight-color:transparent}" +
      ".sk-chat__close:hover{opacity:1;background:rgba(255,255,255,.1)}" +
      ".sk-chat__close:active{opacity:1;background:rgba(255,255,255,.15)}" +
      ".sk-chat__close svg{width:20px;height:20px;fill:currentColor}" +

      // ── Messages ──
      ".sk-chat__messages{flex:1;overflow-y:auto;padding:16px;display:flex;flex-direction:column;gap:8px;min-height:200px;max-height:380px;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;scrollbar-width:thin;scrollbar-color:#c4d6cf transparent}" +
      ".sk-chat__messages::-webkit-scrollbar,.sk-chat__prechat::-webkit-scrollbar,.sk-chat__input::-webkit-scrollbar{width:6px;height:6px}" +
      ".sk-chat__messages::-webkit-scrollbar-track,.sk-chat__prechat::-webkit-scrollbar-track,.sk-chat__input::-webkit-scrollbar-track{background:transparent}" +
      ".sk-chat__messages::-webkit-scrollbar-thumb,.sk-chat__prechat::-webkit-scrollbar-thumb,.sk-chat__input::-webkit-scrollbar-thumb{background:#c4d6cf;border-radius:3px}" +
      ".sk-chat__messages::-webkit-scrollbar-thumb:hover,.sk-chat__prechat::-webkit-scrollbar-thumb:hover{background:#9bbbb0}" +
      ".sk-chat__messages::-webkit-scrollbar-button,.sk-chat__prechat::-webkit-scrollbar-button,.sk-chat__input::-webkit-scrollbar-button{display:none;height:0;width:0}" +
      ".sk-chat__msg{max-width:85%;padding:10px 14px;border-radius:16px;font-size:14px;line-height:1.45;word-wrap:break-word;white-space:pre-wrap}" +
      ".sk-chat__msg--visitor{align-self:flex-end;background:#01a071;color:#fff;border-bottom-right-radius:6px}" +
      ".sk-chat__msg--assistant{align-self:flex-start;background:#f8f8f8;color:#0b0b0b;border-bottom-left-radius:6px}" +
      ".sk-chat__msg--system{align-self:center;background:transparent;color:#423f3d;font-size:12px;text-align:center;padding:4px 10px}" +
      ".sk-chat__msg-time{font-size:10px;color:#423f3d;opacity:.6;margin-top:4px}" +

      // ── Typing ──
      ".sk-chat__typing{padding:4px 16px 8px;font-size:12px;color:#423f3d;display:none;flex-shrink:0}" +
      ".sk-chat__typing.sk-chat--show{display:block}" +

      // Animated typing dots inside the assistant bubble while the model
      // is generating but no text token has arrived yet.
      "@keyframes sk-dots{0%,80%,100%{opacity:.2;transform:translateY(0)}40%{opacity:1;transform:translateY(-3px)}}" +
      ".sk-chat__dots{display:inline-flex;gap:3px;align-items:center;height:14px;vertical-align:middle}" +
      ".sk-chat__dots span{width:6px;height:6px;border-radius:50%;background:#014c40;display:inline-block;animation:sk-dots 1.2s ease-in-out infinite}" +
      ".sk-chat__dots span:nth-child(2){animation-delay:.15s}" +
      ".sk-chat__dots span:nth-child(3){animation-delay:.3s}" +
      ".sk-chat__msg-status-wrap{display:flex;align-items:center;gap:8px;font-size:12px;color:#014c40;opacity:.85;font-style:italic}" +
      ".sk-chat__msg--assistant.sk-chat__msg--thinking{background:#f0fbf6;border:1px dashed #c4e3d4}" +

      // ── Input area ──
      ".sk-chat__input-area{display:flex;flex-direction:column;gap:8px;padding:12px 16px;border-top:1px solid #e1e1e1;background:#f8f8f8;flex-shrink:0}" +
      ".sk-chat__input-row{display:flex;align-items:flex-end;gap:8px;width:100%}" +
      ".sk-chat__attach,.sk-chat__camera{width:40px;height:40px;border-radius:50%;background:#fff;border:1px solid #d6e2dd;cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:background .2s,border-color .2s;-webkit-tap-highlight-color:transparent}" +
      ".sk-chat__attach:hover,.sk-chat__camera:hover{background:#f0fbf6;border-color:#01a071}" +
      ".sk-chat__attach svg,.sk-chat__camera svg{width:18px;height:18px;fill:#028060}" +
      ".sk-chat__attach input[type='file'],.sk-chat__camera input[type='file']{display:none}" +
      ".sk-chat__camera{display:none}" +
      ".sk-chat__sr{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}" +
      ".sk-chat__attach-preview{display:flex;flex-wrap:wrap;gap:6px}" +
      ".sk-chat__attach-preview:empty{display:none}" +
      ".sk-chat__attach-thumb{position:relative;width:60px;height:60px;border-radius:8px;border:1px solid #e1e1e1;overflow:hidden;background:#fff}" +
      ".sk-chat__attach-thumb img{width:100%;height:100%;object-fit:cover;display:block}" +
      ".sk-chat__attach-remove{position:absolute;top:2px;right:2px;width:20px;height:20px;border-radius:50%;background:rgba(0,0,0,.6);color:#fff;border:none;cursor:pointer;font-size:14px;line-height:1;display:flex;align-items:center;justify-content:center;padding:0}" +
      ".sk-chat__attach-remove:hover{background:rgba(0,0,0,.8)}" +
      ".sk-chat__msg-image{max-width:240px;max-height:240px;border-radius:8px;display:block;margin-top:4px}" +
      // ── OpenInsect app card (shown while a photo is being identified) ──
      ".sk-chat__appcard{align-self:flex-start;max-width:85%;background:#fff;border:1px solid #a4d7bc;border-left:3px solid #01a071;border-radius:12px;padding:10px 14px;font-size:13px;color:#0b0b0b}" +
      ".sk-chat__appcard-title{font-weight:800;font-family:Montserrat,Helvetica,Arial,sans-serif;color:#014c40;margin-bottom:3px}" +
      ".sk-chat__appcard-text{color:#423f3d;line-height:1.4;margin-bottom:8px}" +
      ".sk-chat__appcard-links{display:flex;flex-wrap:wrap;gap:8px}" +
      ".sk-chat__appcard-links a{display:inline-block;padding:7px 12px;border-radius:999px;background:#014c40;color:#fff;text-decoration:none;font-size:12px;font-weight:700;font-family:Montserrat,Helvetica,Arial,sans-serif}" +
      ".sk-chat__appcard-links a:hover{background:#028060}" +
      ".sk-chat__input{flex:1;border:1px solid #e1e1e1;border-radius:22px;padding:11px 16px;font-size:16px;resize:none;outline:none;min-height:44px;max-height:96px;font-family:inherit;line-height:1.4;color:#0b0b0b;-webkit-appearance:none;scrollbar-width:thin;scrollbar-color:#c4d6cf transparent;transition:border-color .15s,box-shadow .15s}" +
      ".sk-chat__input:focus{border-color:#01a071;box-shadow:0 0 0 2px rgba(1,160,113,.15)}" +

      // ── Send button (44x44 touch target) ──
      ".sk-chat__send{width:40px;height:40px;border-radius:50%;background:#01a071;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:background .2s,transform .15s;-webkit-tap-highlight-color:transparent;box-shadow:0 2px 6px rgba(1,160,113,.25)}" +
      ".sk-chat__send:hover{background:#028060}" +
      ".sk-chat__send:active{background:#014c40}" +
      ".sk-chat__send:disabled{background:#e1e1e1;cursor:not-allowed}" +
      ".sk-chat__send svg{width:18px;height:18px;fill:#fff}" +

      // ── Contact form ──
      ".sk-chat__contact{padding:16px;background:#f8f8f8;border-top:1px solid #fed176;display:none;flex-shrink:0}" +
      ".sk-chat__contact.sk-chat--show{display:block}" +
      ".sk-chat__contact-title{font-size:14px;font-weight:700;color:#014c40;margin-bottom:8px;font-family:Montserrat,Helvetica,Arial,sans-serif}" +
      ".sk-chat__contact input{width:100%;padding:10px 12px;border:1px solid #e1e1e1;border-radius:8px;font-size:16px;margin-bottom:8px;outline:none;font-family:inherit;color:#0b0b0b;-webkit-appearance:none;box-sizing:border-box}" +
      ".sk-chat__contact input:focus{border-color:#01a071;box-shadow:0 0 0 2px rgba(1,160,113,.15)}" +
      ".sk-chat__contact-btn{width:100%;padding:12px;border-radius:8px;background:#014c40;color:#fff;border:none;cursor:pointer;font-size:14px;font-weight:600;transition:background .2s;font-family:Montserrat,Helvetica,Arial,sans-serif;min-height:44px;-webkit-tap-highlight-color:transparent}" +
      ".sk-chat__contact-btn:hover{background:#028060}" +
      ".sk-chat__contact-btn:active{background:#028060}" +
      ".sk-chat__contact-btn:disabled{background:#e1e1e1;color:#423f3d;cursor:not-allowed}" +
      ".sk-chat__contact-success{text-align:center;color:#014c40;font-size:14px;padding:8px 0}" +

      // ── Igel walk animation ──
      "@keyframes sk-igel-walk{0%{transform:translateX(-120px) scaleX(-1)}50%{transform:translateX(120px) scaleX(-1)}50.01%{transform:translateX(120px) scaleX(1)}100%{transform:translateX(-120px) scaleX(1)}}" +
      "@keyframes sk-igel-bob{0%,100%{transform:translateY(0)}50%{transform:translateY(-3px)}}" +
      ".sk-chat__igel-walk{animation:sk-igel-walk 6s ease-in-out infinite;display:inline-block}" +
      ".sk-chat__igel-walk img{animation:sk-igel-bob .35s ease-in-out infinite;display:block}" +
      ".sk-chat__igel-walk.sk-chat--stopped{animation:none;transform:scaleX(-1)}" +
      ".sk-chat__igel-walk.sk-chat--stopped img{animation:none}" +

      // ── Pre-chat: nur 3 Beispiel-Chips, KEIN Welcome-Bubble, KEIN Email-Feld,
      //    KEIN „Chat starten“-Button. User tippt direkt in den Input unten ODER
      //    klickt einen Chip. Header reicht als Begrüßung.
      //    Chips stehen oben (justify:flex-start) statt vertikal zentriert,
      //    damit sie sofort sichtbar sind und nicht unten klemmen.
      ".sk-chat__prechat{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:flex-start;padding:20px 20px 16px;text-align:center;overflow-y:auto;scrollbar-width:thin;scrollbar-color:#c4d6cf transparent;gap:12px}" +
      ".sk-chat__prechat-text,.sk-chat__examples-title,.sk-chat__prechat input,.sk-chat__prechat-btn,.sk-chat__prechat-hint{display:none!important}" +
      ".sk-chat__examples{display:flex;flex-direction:column;gap:10px;width:100%;max-width:320px}" +
      ".sk-chat__example-chip{display:block;width:100%;padding:14px 18px;border-radius:14px;border:1px solid #e1e1e1;background:#fff;color:#014c40;font-size:14px;font-weight:500;font-family:inherit;text-align:left;cursor:pointer;box-shadow:0 1px 2px rgba(0,0,0,.04);transition:background .15s,border-color .15s,transform .15s,box-shadow .15s;-webkit-tap-highlight-color:transparent;line-height:1.35}" +
      ".sk-chat__example-chip:hover{background:#f0fbf6;border-color:#01a071;transform:translateY(-1px);box-shadow:0 3px 8px rgba(1,160,113,.12)}" +
      ".sk-chat__example-chip:active{transform:translateY(0);box-shadow:0 1px 2px rgba(0,0,0,.04)}" +

      // ── Product links ──
      ".sk-chat__link{color:#01a071;text-decoration:underline;text-underline-offset:2px;word-break:break-word}" +
      ".sk-chat__link:hover{color:#028060}" +
      ".sk-chat__msg strong{font-weight:700}" +

      // ── Antwortknöpfe der interaktiven Bestimmung (2026-10-20) ──
      ".sk-chat__qr{display:flex;flex-wrap:wrap;gap:6px;align-self:flex-start;max-width:92%;margin:0 0 4px}" +
      ".sk-chat__qr-btn{min-height:40px;padding:8px 14px;border-radius:20px;border:1px solid #028060;background:#fff;color:#014c40;font-size:14px;font-weight:500;font-family:inherit;line-height:1.3;text-align:left;cursor:pointer;-webkit-tap-highlight-color:transparent;transition:background .15s,border-color .15s}" +
      ".sk-chat__qr-btn:hover{background:#f0fbf6;border-color:#01a071}" +
      ".sk-chat__qr-btn:focus-visible{outline:none;background:#f0fbf6;border-color:#01a071;box-shadow:0 0 0 3px rgba(1,160,113,.3)}" +
      ".sk-chat__qr-btn--ctl{border-color:#e1e1e1;background:#f8f8f8;color:#423f3d}" +
      "@media(max-width:768px){.sk-chat__qr{max-width:100%}.sk-chat__qr-btn{min-height:44px}}" +
      ".sk-chat__msg-status{font-size:11px;color:#014c40;opacity:.75;margin-top:6px;font-style:italic;display:none}" +
      ".sk-chat__msg--assistant .sk-chat__msg-text{display:block}" +

      // ── Drag & Drop zone ──
      ".sk-chat__dropzone{position:absolute;inset:8px;background:rgba(1,160,113,.08);border:3px dashed #01a071;border-radius:16px;display:none;align-items:center;justify-content:center;pointer-events:none;z-index:10;font-size:15px;color:#014c40;font-weight:700;font-family:Montserrat,Helvetica,Arial,sans-serif;text-align:center;padding:24px;backdrop-filter:blur(2px)}" +
      ".sk-chat__window.sk-chat--dragging .sk-chat__dropzone{display:flex}" +
      ".sk-chat__dropzone svg{width:32px;height:32px;fill:#01a071;display:block;margin:0 auto 8px}" +

      // ── Body scroll lock class ──
      ".sk-chat--body-locked{overflow:hidden!important;position:fixed!important;width:100%!important;height:100%!important}" +

      // ── Call button (in header) ──
      ".sk-chat__callbtn{background:none;border:none;color:#fff;cursor:pointer;opacity:.85;width:44px;height:44px;border-radius:8px;display:flex;align-items:center;justify-content:center;flex-shrink:0;-webkit-tap-highlight-color:transparent;margin-right:2px}" +
      ".sk-chat__callbtn:hover{opacity:1;background:rgba(255,255,255,.1)}" +
      ".sk-chat__callbtn:active{opacity:1;background:rgba(255,255,255,.15)}" +
      ".sk-chat__callbtn svg{width:20px;height:20px;fill:currentColor}" +
      ".sk-chat__callbtn[disabled]{opacity:.45;cursor:default}" +
      // ── Voice bar (sticky strip below header while a call is live) ──
      ".sk-chat__voicebar{display:none;align-items:center;gap:10px;padding:8px 14px;background:#01a071;color:#fff;flex-shrink:0;font-size:13px;font-family:Helvetica,Arial,sans-serif}" +
      ".sk-chat__voicebar.sk-chat--show{display:flex}" +
      ".sk-chat__voicedot{width:10px;height:10px;border-radius:50%;background:#fff;flex-shrink:0;animation:sk-voice-pulse 1.2s ease-in-out infinite}" +
      "@keyframes sk-voice-pulse{0%,100%{opacity:.4;transform:scale(.85)}50%{opacity:1;transform:scale(1.1)}}" +
      ".sk-chat__voicebar-text{flex:1;font-weight:600;letter-spacing:.2px}" +
      ".sk-chat__voicebar-btn{background:rgba(255,255,255,.2);color:#fff;border:none;border-radius:18px;padding:6px 12px;font-size:12px;font-weight:600;cursor:pointer;font-family:inherit;-webkit-tap-highlight-color:transparent;min-height:32px;display:flex;align-items:center;gap:5px}" +
      ".sk-chat__voicebar-btn:hover{background:rgba(255,255,255,.3)}" +
      ".sk-chat__voicebar-btn:active{background:rgba(255,255,255,.35)}" +
      ".sk-chat__voicebar-btn--hangup{background:#c0392b}" +
      ".sk-chat__voicebar-btn--hangup:hover{background:#a93423}" +
      ".sk-chat__voicebar-btn svg{width:14px;height:14px;fill:currentColor}" +
      ".sk-chat__msg--live{opacity:.78;font-style:italic}" +

      // ── Mobile (< 768px) ──
      "@media(max-width:767px){" +
        // Fullscreen window with safe area insets
        ".sk-chat__window{" +
          "inset:0;width:100%;max-height:none;height:100%;border-radius:0;" +
          "padding-top:env(safe-area-inset-top);" +
          "padding-bottom:env(safe-area-inset-bottom);" +
          // Slide-up animation
          "transform:translateY(100%);opacity:0;transition:transform .3s cubic-bezier(.32,.72,0,1),opacity .15s ease" +
        "}" +
        ".sk-chat__window.sk-chat--open{" +
          "display:flex;transform:translateY(0);opacity:1" +
        "}" +
        // Always render window (needed for animation), hide via transform
        ".sk-chat__window{display:flex}" +
        // Messages take all available space
        ".sk-chat__messages{max-height:none;flex:1;min-height:0}" +
        // Bubble position: siehe Block "bis 768px" unten
        // Hide bubble when chat is open
        ".sk-chat__bubble.sk-chat--hidden{opacity:0;pointer-events:none;transform:scale(0.5)}" +
        // Slightly larger touch targets on mobile
        ".sk-chat__close{width:48px;height:48px}" +
        // Safe area on input area
        ".sk-chat__input-area{padding-bottom:max(12px,env(safe-area-inset-bottom))}" +
        // Limit textarea height on mobile (keyboard takes space)
        ".sk-chat__input{max-height:80px;padding:11px 14px}" +
        // Show camera button on mobile
        ".sk-chat__camera{display:flex}" +
        // Tighter row gaps to fit camera + attach + textarea + send
        ".sk-chat__input-row{gap:6px}" +
        ".sk-chat__input-area{padding-left:12px;padding-right:12px}" +
      "}" +

      // ── Bubble bis 768px (2026-09-25): kompakter + verdeckt keine Bedienelemente ──
      // --tucked = beim Runterscrollen weggeschoben (Hochscrollen holt sie zurück),
      // --dodge  = läge über einem Bedienelement (z. B. Teilen-Button im Shorts-Video).
      // Steuerung: initBubbleAutoHide(). Desktop (> 768px) bleibt unverändert.
      "@media(max-width:768px){" +
        ".sk-chat__bubble{width:48px;height:48px;right:12px;bottom:calc(12px + env(safe-area-inset-bottom,0px));transition:transform .25s ease,opacity .2s ease,background .2s}" +
        ".sk-chat__bubble svg{width:24px;height:24px}" +
        ".sk-chat__bubble.sk-chat--tucked,.sk-chat__bubble.sk-chat--dodge{transform:translateY(calc(100% + 32px));opacity:0;pointer-events:none}" +
      "}" +
      "@media(max-width:768px) and (prefers-reduced-motion:reduce){" +
        ".sk-chat__bubble.sk-chat--tucked,.sk-chat__bubble.sk-chat--dodge{transform:none}" +
      "}";
    document.head.appendChild(style);
  }

  // ── Bubble-Autohide bis 768px (2026-09-25) ────────────────────────────
  // Auf kleinen Viewports lag die Bubble über Bedienelementen (Teilen-Button im
  // Shorts-Video, Buttons/Links auf Lexikon-Seiten). Regeln:
  //  1. Runterscrollen (ab 160px) und das Seitenende (Footer) schieben die Bubble weg,
  //     Hochscrollen holt sie zurück.
  //  2. Läge die Bubble über einem kleinen Bedienelement (>= 20 % seiner Fläche
  //     verdeckt), wird sie ausgeblendet, bis die Stelle wieder frei ist. Große
  //     klickbare Flächen (Produktkarten, Video-Tap-Layer, Karten) zählen nicht.
  //  3. Sichtbar bleibt sie immer bei offenem Chat, ungelesener Nachricht oder
  //     Tastatur-Fokus. Programmatic .click() (SKOpenChat, KI-Berater) geht immer.
  var BUBBLE_CONTROL_SEL =
    'a[href],button,input,select,textarea,label,summary,[role="button"],[role="link"],' +
    '[role="tab"],[role="checkbox"],[role="switch"],[role="slider"],[tabindex]:not([tabindex="-1"])';

  function bubbleCompact() {
    return window.matchMedia
      ? window.matchMedia("(max-width: 768px)").matches
      : window.innerWidth <= 768;
  }

  function bubbleCoversControl() {
    if (!document.elementsFromPoint) return false;
    // offsetLeft/Top ignorieren transform -> Ruheposition, auch wenn gerade weggeschoben
    var x0 = bubble.offsetLeft,
      y0 = bubble.offsetTop,
      w = bubble.offsetWidth,
      h = bubble.offsetHeight;
    if (!w || !h) return false;
    var pad = 4;
    var bx1 = x0 - pad,
      by1 = y0 - pad,
      bx2 = x0 + w + pad,
      by2 = y0 + h + pad;
    var pts = [
      [x0 + w / 2, y0 + h / 2],
      [x0 + 5, y0 + 5],
      [x0 + w - 5, y0 + 5],
      [x0 + 5, y0 + h - 5],
      [x0 + w - 5, y0 + h - 5],
    ];
    var checked = [];
    for (var i = 0; i < pts.length; i++) {
      var els = document.elementsFromPoint(pts[i][0], pts[i][1]);
      for (var j = 0; j < els.length; j++) {
        var el = els[j];
        if (el === bubble || bubble.contains(el)) continue;
        // nur das oberste Element unter der Bubble zählt
        var ctl = el.closest ? el.closest(BUBBLE_CONTROL_SEL) : null;
        if (ctl && checked.indexOf(ctl) === -1 && !(win && win.contains(ctl))) {
          checked.push(ctl);
          var r = ctl.getBoundingClientRect();
          var area = r.width * r.height;
          if (area > 0) {
            var ox = Math.max(0, Math.min(bx2, r.right) - Math.max(bx1, r.left));
            var oy = Math.max(0, Math.min(by2, r.bottom) - Math.max(by1, r.top));
            if ((ox * oy) / area >= 0.2) return true;
          }
        }
        break;
      }
    }
    return false;
  }

  function initBubbleAutoHide() {
    var lastY = window.pageYOffset || 0;
    var tucked = false;
    var dodging = false;
    var ticking = false;
    var idleTimer = null;

    function forceVisible() {
      return (
        !bubbleCompact() ||
        state.open ||
        (badge && badge.style.display === "flex") ||
        document.activeElement === bubble
      );
    }

    function apply() {
      var force = forceVisible();
      bubble.classList.toggle("sk-chat--tucked", tucked && !force);
      bubble.classList.toggle("sk-chat--dodge", dodging && !force);
    }

    function checkDodge() {
      if (document.hidden) return;
      dodging = bubbleCompact() && !state.open ? bubbleCoversControl() : false;
      apply();
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var y = window.pageYOffset || document.documentElement.scrollTop || 0;
        var dy = y - lastY;
        var docH = document.documentElement.scrollHeight;
        var vh = window.innerHeight;
        // Seitenende (Footer mit Links + Pflichthinweisen): Bubble bleibt weg,
        // ausser die Seite ist so kurz, dass Anfang und Ende zusammenfallen.
        var atBottom = docH > vh + 400 && y + vh >= docH - 96;
        if (y <= 160) {
          tucked = false;
          lastY = y;
        } else if (atBottom) {
          tucked = true;
          lastY = y;
        } else if (Math.abs(dy) >= 8) {
          tucked = dy > 0;
          lastY = y;
        }
        apply();
        clearTimeout(idleTimer);
        idleTimer = setTimeout(checkDodge, 140);
      });
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", function () {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(checkDodge, 140);
    });
    bubble.addEventListener("focus", apply);
    bubble.addEventListener("blur", apply);
    // Inhalte ändern sich auch ohne Scrollen (Slider, Lazy-Sections, Video-Controls)
    setInterval(checkDodge, 1200);
    setTimeout(checkDodge, 300);
    checkDodge();
  }

  // ── SVG Icons ───────────────────────────────────────────────────────────
  var ICON_CHAT =
    '<svg viewBox="0 0 24 24"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"/></svg>';
  var ICON_CLOSE =
    '<svg viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>';
  var ICON_SEND =
    '<svg viewBox="0 0 24 24"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>';
  var ICON_PAPERCLIP =
    '<svg viewBox="0 0 24 24"><path d="M16.5 6v11.5a4 4 0 0 1-8 0V5a2.5 2.5 0 0 1 5 0v10.5a1 1 0 0 1-2 0V6H10v9.5a2.5 2.5 0 0 0 5 0V5a4 4 0 0 0-8 0v12.5a5.5 5.5 0 0 0 11 0V6h-1.5z"/></svg>';
  var ICON_CALL =
    '<svg viewBox="0 0 24 24"><path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/></svg>';
  var ICON_HANGUP =
    '<svg viewBox="0 0 24 24"><path d="M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08C.11 12.9 0 12.65 0 12.38c0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .27-.11.52-.29.7l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.11-.7-.28-.79-.73-1.68-1.36-2.66-1.85-.33-.16-.56-.51-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z"/></svg>';
  var ICON_MIC =
    '<svg viewBox="0 0 24 24"><path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5-3c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"/></svg>';
  var ICON_MIC_OFF =
    '<svg viewBox="0 0 24 24"><path d="M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zM14.98 11.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3-1.54 0-2.79 1.16-2.96 2.65L14.98 11.17zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.55-.9L19.73 21 21 19.73 4.27 3z"/></svg>';
  var ICON_CAMERA =
    '<svg viewBox="0 0 24 24"><path d="M9 3L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2h-3.17L15 3H9zm3 14a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/></svg>';

  // ── Body Scroll Lock ──────────────────────────────────────────────────
  var scrollLockY = 0;

  function lockBodyScroll() {
    if (!isMobile()) return;
    scrollLockY = window.scrollY;
    document.body.classList.add("sk-chat--body-locked");
    document.body.style.top = -scrollLockY + "px";
  }

  function unlockBodyScroll() {
    if (!document.body.classList.contains("sk-chat--body-locked")) return;
    document.body.classList.remove("sk-chat--body-locked");
    document.body.style.top = "";
    window.scrollTo(0, scrollLockY);
  }

  // ── iOS Keyboard / VisualViewport Handling ────────────────────────────
  function setupViewportHandler() {
    if (!window.visualViewport) return;

    window.visualViewport.addEventListener("resize", function () {
      if (!state.open || !isMobile()) return;
      // On iOS, when keyboard opens, visualViewport.height shrinks
      // Adjust the chat window height to fit above the keyboard
      var vpHeight = window.visualViewport.height;
      win.style.height = vpHeight + "px";
      // Scroll messages to bottom when keyboard opens
      scrollToBottom();
    });

    window.visualViewport.addEventListener("scroll", function () {
      if (!state.open || !isMobile()) return;
      // Keep window pinned to top of visual viewport
      win.style.top = window.visualViewport.offsetTop + "px";
    });
  }

  function resetViewport() {
    win.style.height = "";
    win.style.top = "";
  }

  // ── DOM Construction ────────────────────────────────────────────────────
  function buildUI() {
    // Bubble
    bubble = document.createElement("button");
    bubble.className = "sk-chat__bubble";
    bubble.setAttribute("aria-label", t.openChat);
    bubble.innerHTML = ICON_CHAT;
    badge = document.createElement("span");
    badge.className = "sk-chat__badge";
    bubble.appendChild(badge);
    bubble.addEventListener("click", toggleChat);

    // Window
    win = document.createElement("div");
    win.className = "sk-chat__window";
    win.setAttribute("role", "dialog");
    win.setAttribute("aria-label", t.chatLabel);

    // Header
    var header = document.createElement("div");
    header.className = "sk-chat__header";
    header.innerHTML =
      '<div class="sk-chat__header-icon" style="background:transparent">' +
      '<img src="https://silberkraft.com/cdn/shop/files/Patricia-and-Philipp-Founder-Foto_Artboard-1.png?width=80" alt="Patricia">' +
      "</div>" +
      '<div class="sk-chat__header-text">' +
      '<div class="sk-chat__header-title">' + t.headerTitle + '</div>' +
      "</div>";
    // Call button (left of close)
    if (VOICE_ENABLED && WORKLET_URL) {
      callBtn = document.createElement("button");
      callBtn.className = "sk-chat__callbtn";
      callBtn.setAttribute("aria-label", t.callStart);
      callBtn.setAttribute("title", t.callStart);
      callBtn.innerHTML = ICON_CALL;
      callBtn.addEventListener("click", onCallButtonClick);
      header.appendChild(callBtn);
    }

    var closeBtn = document.createElement("button");
    closeBtn.className = "sk-chat__close";
    closeBtn.setAttribute("aria-label", t.closeChat);
    closeBtn.innerHTML = ICON_CLOSE;
    closeBtn.addEventListener("click", toggleChat);
    header.appendChild(closeBtn);
    win.appendChild(header);

    // Voice bar — shown only while a call is live
    voiceBar = document.createElement("div");
    voiceBar.className = "sk-chat__voicebar";
    var voiceDot = document.createElement("span");
    voiceDot.className = "sk-chat__voicedot";
    voiceStatusEl = document.createElement("span");
    voiceStatusEl.className = "sk-chat__voicebar-text";
    voiceStatusEl.textContent = t.callConnecting;
    voiceMuteBtn = document.createElement("button");
    voiceMuteBtn.className = "sk-chat__voicebar-btn";
    voiceMuteBtn.innerHTML = ICON_MIC;
    voiceMuteBtn.setAttribute("aria-label", t.callMute);
    voiceMuteBtn.addEventListener("click", toggleVoiceMute);
    voiceHangupBtn = document.createElement("button");
    voiceHangupBtn.className = "sk-chat__voicebar-btn sk-chat__voicebar-btn--hangup";
    voiceHangupBtn.innerHTML = ICON_HANGUP;
    voiceHangupBtn.setAttribute("aria-label", t.callStop);
    voiceHangupBtn.addEventListener("click", function () { endCall("user-hangup"); });
    voiceBar.appendChild(voiceDot);
    voiceBar.appendChild(voiceStatusEl);
    voiceBar.appendChild(voiceMuteBtn);
    voiceBar.appendChild(voiceHangupBtn);
    win.appendChild(voiceBar);

    // Messages area
    messagesEl = document.createElement("div");
    messagesEl.className = "sk-chat__messages";
    win.appendChild(messagesEl);

    // Typing indicator
    typingEl = document.createElement("div");
    typingEl.className = "sk-chat__typing";
    typingEl.textContent = t.typing;
    win.appendChild(typingEl);

    // Pre-chat: nur die 3 Beispiel-Chips. Welcome-Bubble, Email-Feld, Start-Button
    // und Hinweis sind weg — User tippt direkt in den Input ODER klickt einen Chip.
    preChatOverlay = document.createElement("div");
    preChatOverlay.className = "sk-chat__prechat";
    preChatOverlay.innerHTML =
      '<div class="sk-chat__examples">' +
        (t.example1 ? '<button type="button" class="sk-chat__example-chip" data-example="1">' + t.example1 + '</button>' : '') +
        (t.example2 ? '<button type="button" class="sk-chat__example-chip" data-example="2">' + t.example2 + '</button>' : '') +
        (t.example3 ? '<button type="button" class="sk-chat__example-chip" data-example="3">' + t.example3 + '</button>' : '') +
      '</div>';
    preChatOverlay.style.display = "none";
    win.appendChild(preChatOverlay);

    // Contact form overlay
    contactOverlay = document.createElement("div");
    contactOverlay.className = "sk-chat__contact";
    contactOverlay.innerHTML =
      '<div class="sk-chat__contact-title">' + t.contactTitle + '</div>' +
      '<input type="text" id="sk-contact-name" placeholder="' + t.namePlaceholder + '" autocomplete="name">' +
      '<input type="email" id="sk-contact-email" placeholder="' + t.emailRequired + '" autocomplete="email">' +
      '<input type="tel" id="sk-contact-phone" placeholder="' + t.phonePlaceholder + '" autocomplete="tel">' +
      '<button class="sk-chat__contact-btn" id="sk-contact-submit">' + t.submit + '</button>';
    win.appendChild(contactOverlay);

    // Input area (preview row above input row)
    var inputArea = document.createElement("div");
    inputAreaEl = inputArea;
    inputArea.className = "sk-chat__input-area";

    var previewEl = document.createElement("div");
    previewEl.className = "sk-chat__attach-preview";
    previewEl.id = "sk-attach-preview";
    inputArea.appendChild(previewEl);

    var inputRow = document.createElement("div");
    inputRow.className = "sk-chat__input-row";

    function buildFileTrigger(className, ariaLabel, iconHTML, opts) {
      var label = document.createElement("label");
      label.className = className;
      label.title = ariaLabel;
      label.innerHTML = iconHTML + '<span class="sk-chat__sr"></span>';
      label.lastChild.textContent = ariaLabel;
      var input = document.createElement("input");
      input.type = "file";
      input.accept = opts.accept;
      if (opts.capture) input.setAttribute("capture", opts.capture);
      input.addEventListener("change", function (ev) {
        var files = ev.target.files;
        if (!files || files.length === 0) return;
        for (var i = 0; i < files.length; i++) handleAttachmentFile(files[i]);
        ev.target.value = "";
      });
      label.appendChild(input);
      return label;
    }

    // Camera button (mobile only — hidden by CSS on desktop)
    var cameraBtn = buildFileTrigger(
      "sk-chat__camera",
      t.takePhoto || "Foto aufnehmen",
      ICON_CAMERA,
      { accept: "image/*", capture: "environment" }
    );

    // Attach (file picker / gallery)
    var attachBtn = buildFileTrigger(
      "sk-chat__attach",
      t.attachFile || "Bild anhängen",
      ICON_PAPERCLIP,
      { accept: "image/jpeg,image/png,image/webp,image/gif,image/heic,image/heif" }
    );

    inputEl = document.createElement("textarea");
    inputEl.className = "sk-chat__input";
    inputEl.placeholder = t.placeholder;
    inputEl.rows = 1;
    inputEl.setAttribute("autocomplete", "off");
    inputEl.setAttribute("autocorrect", "on");
    inputEl.setAttribute("enterkeyhint", "send");
    inputEl.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        sendMessage();
      }
    });
    inputEl.addEventListener("input", function () {
      autoResizeInput();
      if (!state.sessionId) stopIgelAnimation();
    });
    inputEl.addEventListener("paste", function (e) {
      var items = e.clipboardData && e.clipboardData.items;
      if (!items) return;
      var handled = false;
      for (var i = 0; i < items.length; i++) {
        if (items[i].kind === "file" && items[i].type.indexOf("image/") === 0) {
          var file = items[i].getAsFile();
          if (file) {
            handleAttachmentFile(file);
            handled = true;
          }
        }
      }
      if (handled) e.preventDefault();
    });
    sendBtn = document.createElement("button");
    sendBtn.className = "sk-chat__send";
    sendBtn.innerHTML = ICON_SEND;
    sendBtn.setAttribute("aria-label", t.send);
    sendBtn.addEventListener("click", sendMessage);

    inputRow.appendChild(cameraBtn);
    inputRow.appendChild(attachBtn);
    inputRow.appendChild(inputEl);
    inputRow.appendChild(sendBtn);
    inputArea.appendChild(inputRow);
    win.appendChild(inputArea);

    // Drop zone overlay (shown while dragging files over the window)
    var dropZone = document.createElement("div");
    dropZone.className = "sk-chat__dropzone";
    dropZone.innerHTML =
      '<div>' +
      '<svg viewBox="0 0 24 24"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>' +
      '<div>' + (t.dropHere || "Bild hier ablegen") + '</div>' +
      '</div>';
    win.appendChild(dropZone);

    // Drag & Drop listeners — use counter to handle child enter/leave
    var dragCounter = 0;
    function hasFiles(e) {
      if (!e.dataTransfer || !e.dataTransfer.types) return false;
      var types = e.dataTransfer.types;
      for (var i = 0; i < types.length; i++) {
        if (types[i] === "Files") return true;
      }
      return false;
    }
    win.addEventListener("dragenter", function (e) {
      if (!hasFiles(e)) return;
      e.preventDefault();
      dragCounter++;
      win.classList.add("sk-chat--dragging");
    });
    win.addEventListener("dragover", function (e) {
      if (!hasFiles(e)) return;
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
    });
    win.addEventListener("dragleave", function (e) {
      if (!hasFiles(e)) return;
      dragCounter--;
      if (dragCounter <= 0) {
        dragCounter = 0;
        win.classList.remove("sk-chat--dragging");
      }
    });
    win.addEventListener("drop", function (e) {
      if (!hasFiles(e)) return;
      e.preventDefault();
      dragCounter = 0;
      win.classList.remove("sk-chat--dragging");
      var files = e.dataTransfer.files;
      if (!files) return;
      for (var i = 0; i < files.length; i++) handleAttachmentFile(files[i]);
    });

    document.body.appendChild(bubble);
    document.body.appendChild(win);

    // Pre-chat form submit + email-Enter sind nach UI-Simplification (Mai 2026)
    // weg — User startet entweder via Chip-Klick oder direkt durch Tippen +
    // Send-Button im Input-Bereich unten. Bindings defensiv gebaut für den Fall
    // dass das Pre-Chat-Markup wieder erweitert wird:
    var prechatStartBtn = document.getElementById("sk-prechat-start");
    if (prechatStartBtn) prechatStartBtn.addEventListener("click", startChatFromPreForm);
    var prechatEmailEl = document.getElementById("sk-prechat-email");
    if (prechatEmailEl) {
      prechatEmailEl.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
          e.preventDefault();
          startChatFromPreForm();
        }
      });
    }

    // Example chips — click pre-fills input + starts chat
    var chips = preChatOverlay.querySelectorAll(".sk-chat__example-chip");
    for (var ci = 0; ci < chips.length; ci++) {
      chips[ci].addEventListener("click", function (ev) {
        var raw = ev.currentTarget.textContent || "";
        // Strip leading emoji + whitespace so we send a clean question
        var clean = raw.replace(/^[\s\p{Emoji}‍]+/u, "").trim();
        if (!clean) return;
        inputEl.value = clean;
        autoResizeInput();
        sendMessage();
      });
    }

    // Contact form submit
    document
      .getElementById("sk-contact-submit")
      .addEventListener("click", submitContact);

    // Setup iOS keyboard handler
    setupViewportHandler();
  }

  function autoResizeInput() {
    inputEl.style.height = "auto";
    var maxH = isMobile() ? 80 : 100;
    inputEl.style.height = Math.min(inputEl.scrollHeight, maxH) + "px";
  }

  // ── Toggle Chat ─────────────────────────────────────────────────────────
  function toggleChat() {
    state.open = !state.open;
    if (state.open) {
      win.classList.add("sk-chat--open");
      bubble.innerHTML = ICON_CLOSE;
      bubble.appendChild(badge);
      bubble.setAttribute("aria-label", t.closeChat);
      hideBadge();
      // Hide bubble on mobile (fullscreen chat)
      if (isMobile()) {
        bubble.classList.add("sk-chat--hidden");
        lockBodyScroll();
      }
      if (!state.sessionId) {
        // Skip pre-chat form if customer is logged in (email already known)
        if (window.__SK_CUSTOMER && window.__SK_CUSTOMER.email) {
          initSession();
        } else {
          showPreChat();
        }
      } else if (state.messages.length === 0) {
        // Session restored from localStorage but messages not loaded yet (page navigation)
        loadMessages();
      }
      setTimeout(function () {
        if (state.sessionId) {
          inputEl.focus();
        } else {
          var emailField = document.getElementById("sk-prechat-email");
          if (emailField) emailField.focus();
        }
      }, 300); // Wait for animation
    } else {
      win.classList.remove("sk-chat--open");
      bubble.innerHTML = ICON_CHAT;
      bubble.appendChild(badge);
      bubble.setAttribute("aria-label", t.openChat);
      // Show bubble again
      bubble.classList.remove("sk-chat--hidden");
      unlockBodyScroll();
      resetViewport();
      // Blur input to dismiss keyboard
      inputEl.blur();
    }
  }

  // ── Badge ───────────────────────────────────────────────────────────────
  function showBadge(count) {
    badge.textContent = count;
    badge.style.display = "flex";
  }

  function hideBadge() {
    badge.style.display = "none";
  }

  // ── Session Management ──────────────────────────────────────────────────
  function loadSession() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      var data = JSON.parse(raw);
      if (Date.now() - data.ts > SESSION_TTL_MS) {
        localStorage.removeItem(STORAGE_KEY);
        return false;
      }
      state.sessionId = data.sessionId;
      state.sessionToken = data.sessionToken;
      return true;
    } catch (e) {
      return false;
    }
  }

  function saveSession() {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          sessionId: state.sessionId,
          sessionToken: state.sessionToken,
          ts: Date.now(),
        })
      );
    } catch (e) {
      // localStorage not available
    }
  }

  // ── Pre-Chat Form ────────────────────────────────────────────────────────
  function showPreChat() {
    preChatOverlay.style.display = "flex";
    messagesEl.style.display = "none";
    // Keep input area visible — typing a message is an alternative way to start
    inputAreaEl.style.display = "flex";
  }

  function stopIgelAnimation() {
    var igel = document.getElementById("sk-igel-anim");
    if (igel) igel.classList.add("sk-chat--stopped");
  }

  function hidePreChat() {
    stopIgelAnimation();
    preChatOverlay.style.display = "none";
    messagesEl.style.display = "flex";
    inputAreaEl.style.display = "flex";
  }

  function startChatFromPreForm() {
    var emailField = document.getElementById("sk-prechat-email");
    var email = emailField ? emailField.value.trim() : "";
    state.preChatEmail = email || null;
    hidePreChat();
    initSession();
  }

  function initSession() {
    if (loadSession()) {
      loadMessages();
      return;
    }
    createSession();
  }

  function createSession() {
    state.loading = true;
    var sessionBody = { visitorPage: window.location.href };
    if (state.preChatEmail) {
      sessionBody.visitorEmail = state.preChatEmail;
    }
    // Pass Shopify customer data if logged in (email + name only, no auth flag)
    var customer = window.__SK_CUSTOMER;
    if (customer && customer.email) {
      sessionBody.visitorEmail = customer.email;
      if (customer.name) sessionBody.visitorName = customer.name;
    }
    apiFetch("/chat/sessions", {
      method: "POST",
      body: JSON.stringify(sessionBody),
    })
      .then(function (res) {
        state.sessionId = res.data.sessionId;
        state.sessionToken = res.data.sessionToken;
        saveSession();
        addMessage("assistant", res.data.welcomeMessage, null, true);
        state.loading = false;
        // If Shopify customer is logged in, fire-and-forget verify call.
        // Backend cross-checks customer.id ↔ email via Shopify Admin API
        // and marks the session as `shopifyCustomerVerified` if it passes.
        // This unlocks full order-history lookup without needing the order number.
        tryVerifyShopifyCustomer();
      })
      .catch(function (err) {
        addMessage(
          "system",
          t.chatError
        );
        state.loading = false;
      });
  }

  function tryVerifyShopifyCustomer() {
    var customer = window.__SK_CUSTOMER;
    if (!customer || !customer.id || !customer.email) return;
    if (!state.sessionId || !state.sessionToken) return;
    apiFetch("/chat/sessions/" + state.sessionId + "/verify-shopify-customer", {
      method: "POST",
      headers: { Authorization: "Bearer " + state.sessionToken },
      body: JSON.stringify({
        customerId: String(customer.id),
        email: String(customer.email),
      }),
    }).catch(function () { /* non-fatal: session falls back to 2-factor mode */ });
  }

  function loadMessages() {
    apiFetch("/chat/sessions/" + state.sessionId + "/messages", {
      method: "GET",
      headers: { Authorization: "Bearer " + state.sessionToken },
    })
      .then(function (res) {
        messagesEl.innerHTML = "";
        state.messages = [];
        var list = res.data || [];
        list.forEach(function (msg, idx) {
          var qr = idx === list.length - 1 && msg.role === "assistant" && Array.isArray(msg.quickReplies) && msg.quickReplies.length ? msg.quickReplies : null;
          addMessage(msg.role, qr && typeof msg.display === "string" && msg.display ? msg.display : msg.body, msg.createdAt);
          if (qr) renderQuickReplies(qr, messagesEl.lastElementChild);
        });
      })
      .catch(function () {
        // Session expired — create new one
        localStorage.removeItem(STORAGE_KEY);
        state.sessionId = null;
        state.sessionToken = null;
        createSession();
      });
  }

  // ── Attachments ─────────────────────────────────────────────────────────
  function handleAttachmentFile(file) {
    if (!file || !file.type || file.type.indexOf("image/") !== 0) {
      addMessage("system", "Nur Bilder sind erlaubt (JPG, PNG, WEBP, GIF, HEIC).");
      return;
    }
    if (file.size > MAX_ATTACHMENT_BYTES) {
      addMessage("system", "Das Bild ist zu groß (max. " + Math.round(MAX_ATTACHMENT_BYTES / 1024 / 1024) + " MB).");
      return;
    }
    if (state.pendingAttachments.length >= MAX_ATTACHMENTS) {
      addMessage("system", "Maximal " + MAX_ATTACHMENTS + " Bilder pro Nachricht.");
      return;
    }
    var reader = new FileReader();
    reader.onload = function (e) {
      var dataUrl = e.target.result || "";
      var base64 = String(dataUrl).split(",")[1] || "";
      if (!base64) return;
      state.pendingAttachments.push({
        name: file.name || "image",
        mimeType: file.type,
        dataBase64: base64,
        dataUrl: dataUrl,
      });
      renderAttachmentPreview();
    };
    reader.onerror = function () {
      addMessage("system", "Bild konnte nicht geladen werden.");
    };
    reader.readAsDataURL(file);
  }

  function renderAttachmentPreview() {
    var prev = document.getElementById("sk-attach-preview");
    if (!prev) return;
    prev.innerHTML = "";
    for (var i = 0; i < state.pendingAttachments.length; i++) {
      (function (idx) {
        var att = state.pendingAttachments[idx];
        var thumb = document.createElement("div");
        thumb.className = "sk-chat__attach-thumb";
        var img = document.createElement("img");
        img.src = att.dataUrl;
        img.alt = att.name;
        var rm = document.createElement("button");
        rm.className = "sk-chat__attach-remove";
        rm.type = "button";
        rm.setAttribute("aria-label", "Bild entfernen");
        rm.textContent = "×";
        rm.addEventListener("click", function () {
          state.pendingAttachments.splice(idx, 1);
          renderAttachmentPreview();
        });
        thumb.appendChild(img);
        thumb.appendChild(rm);
        prev.appendChild(thumb);
      })(i);
    }
  }

  // ── Send Message ────────────────────────────────────────────────────────
  function sendMessage() {
    var text = inputEl.value.trim();
    var hasAttachments = state.pendingAttachments.length > 0;
    if (state.loading) return;
    if (!text && !hasAttachments) return;
    if (text && text.length < 2 && !hasAttachments && !/^\d$/.test(text)) return;

    // If no session yet, auto-start one (skip pre-chat form) then send
    if (!state.sessionId) {
      inputEl.value = "";
      inputEl.style.height = "auto";
      state.loading = true;
      sendBtn.disabled = true;
      hidePreChat();
      showTyping();

      // Create session first, then send the message
      var sessionBody = { visitorPage: window.location.href };
      var customer = window.__SK_CUSTOMER;
      if (customer && customer.email) {
        sessionBody.visitorEmail = customer.email;
        if (customer.name) sessionBody.visitorName = customer.name;
      }
      apiFetch("/chat/sessions", {
        method: "POST",
        body: JSON.stringify(sessionBody),
      })
        .then(function (res) {
          state.sessionId = res.data.sessionId;
          state.sessionToken = res.data.sessionToken;
          saveSession();
          // Don't show welcome message — go straight to user's question
          doSendMessage(text);
        })
        .catch(function () {
          hideTyping();
          addMessage("system", t.chatError);
          state.loading = false;
          sendBtn.disabled = false;
        });
      return;
    }

    doSendMessage(text);
  }

  function doSendMessage(text, quickReplyId) {
    clearQuickReplies();
    var attachments = state.pendingAttachments.slice();
    var visitorImages = attachments.map(function (a) {
      return { dataUrl: a.dataUrl, name: a.name };
    });
    addMessage("visitor", text, null, false, visitorImages);
    state.pendingAttachments = [];
    renderAttachmentPreview();
    inputEl.value = "";
    inputEl.style.height = "auto";
    state.loading = true;
    sendBtn.disabled = true;
    showTyping();

    var payload = {
      body: text || "",
      currentPage: window.location.href,
      currentPageTitle: document.title || "",
    };
    if (quickReplyId) payload.quickReply = quickReplyId;
    if (attachments.length > 0) {
      payload.attachments = attachments.map(function (a) {
        return { name: a.name, mimeType: a.mimeType, dataBase64: a.dataBase64 };
      });
    }

    streamMessage(payload);
  }

  // OpenInsect app recommendation card — appended once per session while the
  // first photo is being identified. Built via DOM (no innerHTML) so the link
  // hrefs are safe and the labels stay brand-fixed.
  function appendAppPromo() {
    if (state.appPromoShown) return;
    state.appPromoShown = true;
    var card = document.createElement("div");
    card.className = "sk-chat__appcard";
    var title = document.createElement("div");
    title.className = "sk-chat__appcard-title";
    title.textContent = t.appPromoTitle || "📱 OpenInsect";
    var text = document.createElement("div");
    text.className = "sk-chat__appcard-text";
    text.textContent = t.appPromoText || "";
    var links = document.createElement("div");
    links.className = "sk-chat__appcard-links";
    var ios = document.createElement("a");
    ios.href = APP_IOS_URL;
    ios.target = "_blank";
    ios.rel = "noopener";
    ios.textContent = "App Store";
    var android = document.createElement("a");
    android.href = APP_ANDROID_URL;
    android.target = "_blank";
    android.rel = "noopener";
    android.textContent = "Google Play";
    links.appendChild(ios);
    links.appendChild(android);
    card.appendChild(title);
    card.appendChild(text);
    card.appendChild(links);
    messagesEl.appendChild(card);
    scrollToBottom();
  }

  // ── Antwortknöpfe (interaktive Bestimmung, 2026-10-20) ─────────────────
  // Der Server liefert zu einer Bot-Nachricht quickReplies [{id,label}] und display (Text ohne die
  // nummerierten Antworten). Ein Klick sendet den Knopftext als Nachricht plus das Token
  // (payload.quickReply) für die eindeutige Zuordnung. Es gibt nur die Knöpfe der letzten Nachricht.
  function clearQuickReplies() {
    if (!messagesEl) return;
    var old = messagesEl.querySelectorAll(".sk-chat__qr");
    for (var i = 0; i < old.length; i++) {
      if (old[i].parentNode) old[i].parentNode.removeChild(old[i]);
    }
  }

  function renderQuickReplies(list, msgEl) {
    clearQuickReplies();
    if (!list || !list.length || !messagesEl) return;
    var wrap = document.createElement("div");
    wrap.className = "sk-chat__qr";
    wrap.setAttribute("role", "group");
    if (msgEl) {
      if (!msgEl.id) msgEl.id = "sk-chat-qr-msg-" + new Date().getTime();
      wrap.setAttribute("aria-labelledby", msgEl.id);
    }
    list.forEach(function (q) {
      if (!q || typeof q.id !== "string" || typeof q.label !== "string" || !q.label) return;
      var b = document.createElement("button");
      b.type = "button";
      var answer = /^o:/.test(q.id) || q.id === "u" || q.id === "go" || q.id === "pgo";
      b.className = "sk-chat__qr-btn" + (answer ? "" : " sk-chat__qr-btn--ctl");
      b.textContent = q.label;
      b.addEventListener("click", function () {
        if (state.loading) return;
        clearQuickReplies();
        doSendMessage(q.label, q.id);
      });
      wrap.appendChild(b);
    });
    messagesEl.appendChild(wrap);
    scrollToBottom();
  }

  // SSE streaming sender — falls back to JSON POST on error.
  function streamMessage(payload) {
    var url = API_URL + "/chat/sessions/" + state.sessionId + "/messages/stream";

    // Create the live assistant bubble RIGHT AWAY with an animated dot
    // indicator + status text, so the visitor sees that something is
    // happening even when the model is still in tool-call rounds.
    var bubble = document.createElement("div");
    bubble.className = "sk-chat__msg sk-chat__msg--assistant sk-chat__msg--thinking";

    // Status wrapper (dots + label)
    var statusWrap = document.createElement("div");
    statusWrap.className = "sk-chat__msg-status-wrap";
    var dotsEl = document.createElement("span");
    dotsEl.className = "sk-chat__dots";
    dotsEl.innerHTML = "<span></span><span></span><span></span>";
    // When the visitor uploaded a photo, the long pause is the species-ID
    // pipeline analysing it — show a photo-specific status so the wait is
    // self-explanatory (instead of the generic "preparing an answer").
    var hasImage = !!(payload && payload.attachments && payload.attachments.length);
    var statusLabel = document.createElement("span");
    statusLabel.textContent = hasImage && t.statusPhoto
      ? t.statusPhoto
      : (t.statusThinking || "Antwort wird vorbereitet…");
    statusWrap.appendChild(dotsEl);
    statusWrap.appendChild(statusLabel);
    bubble.appendChild(statusWrap);

    // Text container — empty until first delta arrives.
    var textContainer = document.createElement("div");
    textContainer.className = "sk-chat__msg-text";
    textContainer.style.display = "none";
    bubble.appendChild(textContainer);

    // Append the bubble + remove the "Silberkraft tippt..." indicator below.
    hideTyping();
    // While a photo is being identified (a multi-second wait), recommend the
    // OpenInsect app — thematically perfect and makes the wait useful. Once per
    // session so repeated uploads don't stack cards.
    if (hasImage) appendAppPromo();
    messagesEl.appendChild(bubble);
    scrollToBottom();

    var accumulated = "";
    var finished = false;
    var firstDeltaSeen = false;

    function setStatus(label) {
      statusLabel.textContent = label;
      statusWrap.style.display = "flex";
    }

    // Rotate the status text every ~3s so the visitor sees activity. The
    // phrases are generic (never reveal which tool runs) but vary so it
    // doesn't feel frozen on long tool-call chains.
    var rotationPhrases = Array.isArray(t.statusRotation) && t.statusRotation.length > 0
      ? t.statusRotation
      : [t.statusThinking || "Patricia bereitet die Antwort vor…"];
    // For photo uploads, keep the photo-specific status pinned first so the
    // visitor understands the wait is the image analysis.
    if (hasImage && t.statusPhoto) {
      rotationPhrases = [t.statusPhoto].concat(rotationPhrases);
    }
    var rotationIdx = 0;
    var rotationTimer = setInterval(function () {
      if (firstDeltaSeen || finished) return;
      rotationIdx = (rotationIdx + 1) % rotationPhrases.length;
      setStatus(rotationPhrases[rotationIdx]);
    }, 3000);

    function clearRotation() {
      if (rotationTimer) {
        clearInterval(rotationTimer);
        rotationTimer = null;
      }
    }

    function startTextMode() {
      if (firstDeltaSeen) return;
      firstDeltaSeen = true;
      clearRotation();
      // Drop the "thinking" look + status indicator, show text container
      bubble.classList.remove("sk-chat__msg--thinking");
      statusWrap.style.display = "none";
      textContainer.style.display = "block";
    }

    // Customer-facing: never leak which tool the agent is using ("Schaue nach
    // deiner Bestellung…" → "Durchsuche unsere Inhalte…" reveals internals).
    // Stick to the generic "Patricia bereitet die Antwort vor…" status
    // regardless of which tool fires. Only when the model starts streaming
    // text do we hide the indicator entirely.
    function showToolStatus(_name, _status) {
      if (firstDeltaSeen) return;
      setStatus(t.statusThinking || "Patricia bereitet die Antwort vor…");
    }

    function onError() {
      if (finished) return;
      finished = true;
      clearRotation();
      hideTyping();
      if (messagesEl.contains(bubble)) messagesEl.removeChild(bubble);
      addMessage("system", t.sendError);
      state.loading = false;
      sendBtn.disabled = false;
    }

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + state.sessionToken,
        Accept: "text/event-stream",
      },
      body: JSON.stringify(payload),
    })
      .then(function (response) {
        if (!response.ok) throw new Error("HTTP " + response.status);
        if (!response.body) throw new Error("No body");
        var reader = response.body.getReader();
        var decoder = new TextDecoder();
        var buf = "";

        function processBuffer() {
          var sep;
          while ((sep = buf.indexOf("\n\n")) !== -1) {
            var raw = buf.slice(0, sep);
            buf = buf.slice(sep + 2);
            var lines = raw.split("\n");
            var event = "message";
            var dataLines = [];
            for (var i = 0; i < lines.length; i++) {
              var line = lines[i];
              if (line.indexOf("event:") === 0) event = line.slice(6).trim();
              else if (line.indexOf("data:") === 0) dataLines.push(line.slice(5).trim());
            }
            var data = dataLines.join("\n");
            handleEvent(event, data);
          }
        }

        function handleEvent(event, raw) {
          if (event === "delta") {
            var chunk;
            try { chunk = JSON.parse(raw); }
            catch (_) { chunk = raw; }
            if (typeof chunk !== "string") return;
            startTextMode();
            accumulated += chunk;
            // Replace the text container content with parsed markdown so
            // **bold** and links render correctly even mid-stream.
            textContainer.innerHTML = "";
            renderMessageContent(textContainer, accumulated);
            scrollToBottom();
          } else if (event === "tool") {
            var t1; try { t1 = JSON.parse(raw); } catch (_) { return; }
            showToolStatus(t1.name, t1.status);
          } else if (event === "done") {
            var d; try { d = JSON.parse(raw); } catch (_) { d = null; }
            finished = true;
            clearRotation();
            // Interaktive Bestimmung: mit Antwortknöpfen den Text ohne nummerierte Antworten zeigen.
            var qrList = d && Array.isArray(d.quickReplies) && d.quickReplies.length ? d.quickReplies : null;
            if (qrList && typeof d.display === "string" && d.display) d.body = d.display;
            // Final body might differ slightly (after privacyFilter) — refresh.
            if (d && typeof d.body === "string" && d.body !== accumulated) {
              accumulated = d.body;
              startTextMode();
              textContainer.innerHTML = "";
              renderMessageContent(textContainer, accumulated);
            } else {
              startTextMode();
            }
            if (d && d.createdAt) {
              var timeEl = document.createElement("div");
              timeEl.className = "sk-chat__msg-time";
              var dt = new Date(d.createdAt);
              timeEl.appendChild(document.createTextNode(
                dt.toLocaleTimeString(lang === "de" ? "de-DE" : lang, { hour: "2-digit", minute: "2-digit" })
              ));
              bubble.appendChild(timeEl);
            }
            state.messages.push({ role: "assistant", body: accumulated });
            state.loading = false;
            sendBtn.disabled = false;

            // Contact-form trigger
            var lower = accumulated.toLowerCase();
            if (
              !state.contactSent &&
              (lower.indexOf("kontaktdaten") !== -1 ||
                lower.indexOf("mitarbeiter meldet sich") !== -1 ||
                lower.indexOf("innerhalb von 24") !== -1 ||
                lower.indexOf("rückmeldung") !== -1)
            ) {
              showContactForm();
            }
            if (qrList) renderQuickReplies(qrList, bubble);
            if (!state.open) showBadge("1");
            scrollToBottom();
          } else if (event === "error") {
            onError();
          }
        }

        function pump() {
          return reader.read().then(function (r) {
            if (r.done) {
              if (!finished) {
                // Stream closed without `done` event — best-effort cleanup.
                state.loading = false;
                sendBtn.disabled = false;
                hideTyping();
              }
              return;
            }
            buf += decoder.decode(r.value, { stream: true });
            processBuffer();
            return pump();
          });
        }
        return pump();
      })
      .catch(function () { onError(); });
  }

  // ── Contact Form ────────────────────────────────────────────────────────
  function showContactForm() {
    state.showContactForm = true;
    contactOverlay.classList.add("sk-chat--show");
    scrollToBottom();
  }

  function submitContact() {
    var emailInput = document.getElementById("sk-contact-email");
    var phoneInput = document.getElementById("sk-contact-phone");
    var nameInput = document.getElementById("sk-contact-name");
    var submitBtn = document.getElementById("sk-contact-submit");

    var email = emailInput.value.trim();
    var phone = phoneInput.value.trim();
    var name = nameInput.value.trim();

    if (!email && !phone) {
      emailInput.style.borderColor = "#e74c3c";
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = t.submitting;

    apiFetch("/chat/sessions/" + state.sessionId + "/contact", {
      method: "POST",
      headers: { Authorization: "Bearer " + state.sessionToken },
      body: JSON.stringify({ email: email || undefined, phone: phone || undefined, name: name || undefined }),
    })
      .then(function () {
        state.contactSent = true;
        contactOverlay.innerHTML =
          '<div class="sk-chat__contact-success">' + t.contactSuccess + '</div>';
        setTimeout(function () {
          contactOverlay.classList.remove("sk-chat--show");
        }, 4000);
      })
      .catch(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = t.submit;
        addMessage(
          "system",
          t.contactError
        );
      });
  }

  // ── Typing Indicator ───────────────────────────────────────────────────
  function showTyping() {
    typingEl.classList.add("sk-chat--show");
    scrollToBottom();
  }

  function hideTyping() {
    typingEl.classList.remove("sk-chat--show");
  }

  // ── Render Message ──────────────────────────────────────────────────────
  // Combined parser: markdown links [text](url), bold **text**, and bare URLs.
  // Order matters: links first so we don't double-process the URL inside [].
  // Toleriert "[Titel] (url)" MIT Leerzeichen — das KI-Modell schreibt das
  // gelegentlich so; ohne Toleranz sah der Kunde rohen Markdown-Text
  // (Review 2026-07-17). Neue Bot-Nachrichten werden zusätzlich serverseitig
  // kanonisiert; dies fängt ältere gespeicherte Nachrichten ab.
  var MD_LINK_RE = /\[([^\]]+)\]\s{0,3}\((https?:\/\/[^)\s]+)\)/g;
  var BARE_URL_RE = /\bhttps?:\/\/[^\s)<>"']+/g;
  var BOLD_RE = /\*\*([^*]+)\*\*/g;
  // Backwards-compat alias (used by typewriter)
  var LINK_RE = MD_LINK_RE;

  function parseInlineSegments(body) {
    var segments = [{ type: "text", value: body }];

    function splitByRegex(re, makeNode) {
      var out = [];
      segments.forEach(function (seg) {
        if (seg.type !== "text") { out.push(seg); return; }
        var text = seg.value;
        var lastIndex = 0;
        var match;
        re.lastIndex = 0;
        while ((match = re.exec(text)) !== null) {
          if (match.index > lastIndex) {
            out.push({ type: "text", value: text.slice(lastIndex, match.index) });
          }
          out.push(makeNode(match));
          lastIndex = re.lastIndex;
          if (match.index === re.lastIndex) re.lastIndex++;
        }
        if (lastIndex < text.length) {
          out.push({ type: "text", value: text.slice(lastIndex) });
        }
      });
      segments = out;
    }

    splitByRegex(MD_LINK_RE, function (m) {
      return { type: "link", text: m[1], url: m[2] };
    });
    splitByRegex(BARE_URL_RE, function (m) {
      var url = m[0].replace(/[.,!?;:]+$/, "");
      var trailing = m[0].slice(url.length);
      var node = { type: "link", text: shortenUrl(url), url: url };
      if (trailing) return [node, { type: "text", value: trailing }];
      return node;
    });
    splitByRegex(BOLD_RE, function (m) {
      return { type: "bold", value: m[1] };
    });

    // Flatten nested arrays from splitByRegex (when a match returns multiple parts)
    var flat = [];
    segments.forEach(function (s) {
      if (Array.isArray(s)) s.forEach(function (x) { flat.push(x); });
      else flat.push(s);
    });
    return flat;
  }

  function shortenUrl(url) {
    try {
      var u = new URL(url);
      // For silberkraft links use last path segment as readable text
      if (u.hostname.indexOf("silberkraft") !== -1) {
        var seg = u.pathname.split("/").filter(Boolean).pop() || u.hostname;
        return seg.replace(/-/g, " ");
      }
      return u.hostname + u.pathname;
    } catch (_) {
      return url;
    }
  }

  function appendSegmentTo(el, seg) {
    if (seg.type === "text") {
      el.appendChild(document.createTextNode(seg.value));
    } else if (seg.type === "bold") {
      var b = document.createElement("strong");
      b.appendChild(document.createTextNode(seg.value));
      el.appendChild(b);
    } else if (seg.type === "link") {
      var a = document.createElement("a");
      a.href = seg.url;
      a.target = "_blank";
      a.rel = "noopener";
      a.className = "sk-chat__link";
      a.appendChild(document.createTextNode(seg.text));
      el.appendChild(a);
    }
  }

  function renderMessageContent(el, body) {
    var segments = parseInlineSegments(body);
    segments.forEach(function (seg) { appendSegmentTo(el, seg); });
  }

  // ── Typewriter Effect ────────────────────────────────────────────────────
  function typewriteMessage(el, body, onDone) {
    var segments = parseInlineSegments(body);
    var tokens = [];
    segments.forEach(function (seg) {
      if (seg.type === "link" || seg.type === "bold") {
        tokens.push(seg);
      } else {
        var words = seg.value.split(" ");
        for (var w = 0; w < words.length; w++) {
          var word = (w > 0 ? " " : "") + words[w];
          if (word) tokens.push({ type: "text", value: word });
        }
      }
    });
    var idx = 0;
    function step() {
      if (idx >= tokens.length) {
        if (onDone) onDone();
        return;
      }
      var t = tokens[idx++];
      appendSegmentTo(el, t);
      scrollToBottom();
      setTimeout(step, 25 + Math.random() * 30);
    }
    step();
  }

  function addMessage(role, body, createdAt, animate, images) {
    state.messages.push({ role: role, body: body });
    var el = document.createElement("div");
    el.className = "sk-chat__msg sk-chat__msg--" + role;

    if (images && images.length) {
      for (var imgIdx = 0; imgIdx < images.length; imgIdx++) {
        var imgEl = document.createElement("img");
        imgEl.className = "sk-chat__msg-image";
        imgEl.src = images[imgIdx].dataUrl;
        imgEl.alt = images[imgIdx].name || "Bild";
        el.appendChild(imgEl);
      }
    }

    // Typewriter animation for new AI messages
    if (role === "assistant" && animate) {
      messagesEl.appendChild(el);
      scrollToBottom();
      typewriteMessage(el, body, function () {
        if (createdAt) {
          var timeEl = document.createElement("div");
          timeEl.className = "sk-chat__msg-time";
          var d = new Date(createdAt);
          timeEl.appendChild(
            document.createTextNode(
              d.toLocaleTimeString(lang === "de" ? "de-DE" : lang, { hour: "2-digit", minute: "2-digit" })
            )
          );
          el.appendChild(timeEl);
          scrollToBottom();
        }
      });
      return;
    }

    if (role === "assistant") {
      renderMessageContent(el, body);
    } else {
      // Visitor & system: plain text only (XSS safe)
      el.appendChild(document.createTextNode(body));
    }

    if (createdAt) {
      var timeEl = document.createElement("div");
      timeEl.className = "sk-chat__msg-time";
      var d = new Date(createdAt);
      timeEl.appendChild(
        document.createTextNode(
          d.toLocaleTimeString(lang === "de" ? "de-DE" : lang, { hour: "2-digit", minute: "2-digit" })
        )
      );
      el.appendChild(timeEl);
    }

    messagesEl.appendChild(el);
    scrollToBottom();
  }

  function scrollToBottom() {
    setTimeout(function () {
      messagesEl.scrollTop = messagesEl.scrollHeight;
    }, 50);
  }

  // ── API Fetch ───────────────────────────────────────────────────────────
  function apiFetch(path, opts) {
    var url = API_URL + path;
    var headers = Object.assign(
      { "Content-Type": "application/json" },
      opts.headers || {}
    );

    return fetch(url, {
      method: opts.method || "GET",
      headers: headers,
      body: opts.body || undefined,
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (errBody) {
          throw new Error((errBody.error && errBody.error.message) || t.errorPrefix + " " + res.status);
        });
      }
      return res.json();
    });
  }

  // ── Orientation / Resize Handler ──────────────────────────────────────
  function handleResize() {
    // If chat is open and we switched from mobile to desktop (or vice versa), adjust
    if (state.open) {
      if (!isMobile()) {
        // Switched to desktop — unlock body, reset viewport
        unlockBodyScroll();
        resetViewport();
        bubble.classList.remove("sk-chat--hidden");
      } else {
        // Switched to mobile — lock body, hide bubble
        lockBodyScroll();
        bubble.classList.add("sk-chat--hidden");
      }
    }
  }

  // ── Init ────────────────────────────────────────────────────────────────
  function init() {
    injectStyles();
    buildUI();
    try {
      initBubbleAutoHide();
    } catch (e) {}

    // Öffentliche Mini-API für Seiten-Integrationen (z. B. KI-Schädlingsberater auf der Startseite,
    // assets/sk-hp-advisor.js): SKChat.open() öffnet den Chat, SKChat.ask(text) öffnet ihn und sendet die Frage.
    window.SKChat = {
      open: function () {
        if (!state.open) toggleChat();
      },
      ask: function (text) {
        var q = String(text || "").trim();
        if (!state.open) toggleChat();
        if (q.length < 2) return;
        inputEl.value = q;
        autoResizeInput();
        sendMessage();
      }
    };
    try {
      document.dispatchEvent(new CustomEvent("sk-chat:ready"));
    } catch (e) {}

    // Handle orientation changes and resize
    window.addEventListener("resize", handleResize);

    // Auto-restore session from localStorage
    if (loadSession()) {
      // Session exists but don't auto-open chat
    }
  }

  // ── Voice (Gemini Live API) ───────────────────────────────────────────

  function onCallButtonClick() {
    if (state.voiceStatus === "live" || state.voiceStatus === "connecting") {
      endCall("user-hangup");
    } else {
      if (!state.sessionId) {
        hidePreChat();
        var sessionBody = { visitorPage: window.location.href };
        var customer = window.__SK_CUSTOMER;
        if (customer && customer.email) {
          sessionBody.visitorEmail = customer.email;
          if (customer.name) sessionBody.visitorName = customer.name;
        }
        setVoiceStatus("connecting");
        apiFetch("/chat/sessions", {
          method: "POST",
          body: JSON.stringify(sessionBody),
        })
          .then(function (res) {
            state.sessionId = res.data.sessionId;
            state.sessionToken = res.data.sessionToken;
            saveSession();
            return startCall();
          })
          .catch(function () {
            setVoiceStatus("idle");
            addMessage("system", t.chatError);
          });
        return;
      }
      startCall();
    }
  }

  function setVoiceStatus(status) {
    state.voiceStatus = status;
    if (!voiceBar) return;
    if (status === "idle") {
      voiceBar.classList.remove("sk-chat--show");
      if (callBtn) {
        callBtn.innerHTML = ICON_CALL;
        callBtn.setAttribute("aria-label", t.callStart);
        callBtn.setAttribute("title", t.callStart);
        callBtn.removeAttribute("disabled");
      }
      return;
    }
    voiceBar.classList.add("sk-chat--show");
    if (status === "connecting") {
      voiceStatusEl.textContent = t.callConnecting;
      if (callBtn) callBtn.setAttribute("disabled", "true");
    } else if (status === "live") {
      voiceStatusEl.textContent = t.callLive;
      if (callBtn) {
        callBtn.innerHTML = ICON_HANGUP;
        callBtn.setAttribute("aria-label", t.callStop);
        callBtn.setAttribute("title", t.callStop);
        callBtn.removeAttribute("disabled");
      }
    }
  }

  function startCall() {
    if (!VOICE_ENABLED || !WORKLET_URL) return;
    if (!state.sessionId || !state.sessionToken) {
      addMessage("system", t.callError);
      return;
    }
    setVoiceStatus("connecting");
    state.voiceLiveAssistantText = "";
    state.voiceLiveUserText = "";

    var ticketPromise = apiFetch(
      "/voice/sessions/" + state.sessionId + "/ticket",
      {
        method: "POST",
        headers: { Authorization: "Bearer " + state.sessionToken },
        body: JSON.stringify({ locale: lang }),
      }
    );

    var micPromise = navigator.mediaDevices
      ? navigator.mediaDevices.getUserMedia({
          audio: {
            channelCount: 1,
            echoCancellation: true,
            noiseSuppression: true,
            autoGainControl: true,
          },
        })
      : Promise.reject(new Error("getUserMedia unsupported"));

    Promise.all([ticketPromise, micPromise])
      .then(function (results) {
        var ticketRes = results[0];
        var stream = results[1];
        state.voiceMicStream = stream;
        return setupAudioPipeline().then(function () {
          openVoiceWs(ticketRes.data.ticket);
        });
      })
      .catch(function (err) {
        var msg = (err && err.name === "NotAllowedError")
          ? t.callMicDenied
          : t.callError;
        addMessage("system", msg);
        cleanupVoice();
        setVoiceStatus("idle");
      });
  }

  function setupAudioPipeline() {
    var AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtx) return Promise.reject(new Error("AudioContext unsupported"));
    state.voiceCtx = new AudioCtx();
    return state.voiceCtx.audioWorklet
      .addModule(WORKLET_URL)
      .then(function () {
        var source = state.voiceCtx.createMediaStreamSource(state.voiceMicStream);
        state.voiceMicNode = new AudioWorkletNode(state.voiceCtx, "sk-recorder");
        state.voicePlayerNode = new AudioWorkletNode(state.voiceCtx, "sk-player");
        source.connect(state.voiceMicNode);
        state.voicePlayerNode.connect(state.voiceCtx.destination);

        state.voiceMicNode.port.onmessage = function (evt) {
          if (!evt.data || evt.data.type !== "pcm" || !evt.data.buf) return;
          if (!state.voiceWs || state.voiceWs.readyState !== 1) return;
          state.voiceWs.send(JSON.stringify({
            type: "audio",
            pcm: bufferToBase64(evt.data.buf),
          }));
        };
      });
  }

  function openVoiceWs(ticket) {
    var url = WS_URL + "/voice/sessions/" + state.sessionId + "/ws?ticket=" +
      encodeURIComponent(ticket);
    var ws;
    try {
      ws = new WebSocket(url);
    } catch (err) {
      addMessage("system", t.callError);
      cleanupVoice();
      setVoiceStatus("idle");
      return;
    }
    state.voiceWs = ws;
    ws.addEventListener("message", onVoiceWsMessage);
    ws.addEventListener("close", function () {
      if (state.voiceStatus !== "idle") {
        addMessage("system", t.callEnded);
      }
      cleanupVoice();
      setVoiceStatus("idle");
    });
    ws.addEventListener("error", function () {
      // close fires right after with cleanup
    });
  }

  function onVoiceWsMessage(evt) {
    var data;
    try { data = JSON.parse(evt.data); } catch (e) { return; }
    if (data.type === "ready") {
      setVoiceStatus("live");
      return;
    }
    if (data.type === "audio" && data.pcm) {
      if (!state.voicePlayerNode) return;
      var buf = base64ToArrayBuffer(data.pcm);
      state.voicePlayerNode.port.postMessage({ type: "pcm", buf: buf }, [buf]);
      return;
    }
    if (data.type === "transcript") {
      renderLiveTranscript(data.who, data.text, !!data.final);
      return;
    }
    if (data.type === "turn_complete") {
      clearLiveTranscript();
      return;
    }
    if (data.type === "hangup") {
      endCall("server-hangup");
      return;
    }
    if (data.type === "error") {
      addMessage("system", data.message || t.callError);
      endCall("server-error");
      return;
    }
  }

  function renderLiveTranscript(who, text, isFinal) {
    if (!text) return;
    var role = who === "user" ? "visitor" : "assistant";
    if (isFinal) {
      clearLiveTranscript();
      addMessage(role, text);
      return;
    }
    if (!state.voiceTranscriptEl || state.voiceTranscriptEl.dataset.who !== role) {
      state.voiceTranscriptEl = document.createElement("div");
      state.voiceTranscriptEl.className =
        "sk-chat__msg sk-chat__msg--" + role + " sk-chat__msg--live";
      state.voiceTranscriptEl.dataset.who = role;
      messagesEl.appendChild(state.voiceTranscriptEl);
    }
    state.voiceTranscriptEl.appendChild(document.createTextNode(text));
    scrollToBottom();
  }

  function clearLiveTranscript() {
    if (state.voiceTranscriptEl && state.voiceTranscriptEl.parentNode) {
      state.voiceTranscriptEl.parentNode.removeChild(state.voiceTranscriptEl);
    }
    state.voiceTranscriptEl = null;
  }

  function toggleVoiceMute() {
    state.voiceMuted = !state.voiceMuted;
    if (state.voiceMicNode) {
      state.voiceMicNode.port.postMessage({ type: "mute", muted: state.voiceMuted });
    }
    if (voiceMuteBtn) {
      voiceMuteBtn.innerHTML = state.voiceMuted ? ICON_MIC_OFF : ICON_MIC;
      voiceMuteBtn.setAttribute("aria-label", state.voiceMuted ? t.callUnmute : t.callMute);
    }
  }

  function endCall(reason) {
    if (state.voiceStatus === "ending" || state.voiceStatus === "idle") return;
    state.voiceStatus = "ending";
    if (state.voiceWs && state.voiceWs.readyState === 1) {
      try { state.voiceWs.send(JSON.stringify({ type: "hangup", reason: reason || "client" })); } catch (_) {}
      try { state.voiceWs.close(); } catch (_) {}
    }
    cleanupVoice();
    setVoiceStatus("idle");
  }

  function cleanupVoice() {
    clearLiveTranscript();
    if (state.voiceMicStream) {
      state.voiceMicStream.getTracks().forEach(function (tr) { try { tr.stop(); } catch (_) {} });
      state.voiceMicStream = null;
    }
    if (state.voiceMicNode) {
      try { state.voiceMicNode.disconnect(); } catch (_) {}
      state.voiceMicNode = null;
    }
    if (state.voicePlayerNode) {
      try { state.voicePlayerNode.disconnect(); } catch (_) {}
      state.voicePlayerNode = null;
    }
    if (state.voiceCtx) {
      try { state.voiceCtx.close(); } catch (_) {}
      state.voiceCtx = null;
    }
    state.voiceWs = null;
    state.voiceMuted = false;
    if (voiceMuteBtn) {
      voiceMuteBtn.innerHTML = ICON_MIC;
      voiceMuteBtn.setAttribute("aria-label", t.callMute);
    }
  }

  function bufferToBase64(buf) {
    var bytes = new Uint8Array(buf);
    var binary = "";
    var chunk = 0x8000;
    for (var i = 0; i < bytes.length; i += chunk) {
      binary += String.fromCharCode.apply(
        null,
        bytes.subarray(i, Math.min(i + chunk, bytes.length))
      );
    }
    return btoa(binary);
  }

  function base64ToArrayBuffer(b64) {
    var binary = atob(b64);
    var len = binary.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return bytes.buffer;
  }

  function boot() {
    // Ensure the correct locale dict is resolved BEFORE we build the UI,
    // so header/title/placeholders use the right language on first paint.
    resolveI18n(function () {
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
      } else {
        init();
      }
    });
  }

  boot();
})();
